import React from 'react';
import { connect } from 'react-redux';
import { Button} from 'react-bootstrap';
import SimplePrompt from "../SimplePrompt";
import may from "../../../security";
import {ROLE_ROOT_EMPLOYEE} from "../../../constants";

class CampaignListEntry extends React.Component {

  constructor(props) {
    super(props);
  }

  showDetails = (url) => {
    const {history} = this.props;
    history.push(url);
  }



  render() {
    const {
      campaign,
      messages,
      index,
      showSettings,
      deleting,
      appIntl,
      handleRemoveClick,
      user,
      showCampaigns
    } = this.props;

    const {
      id,
      title,
      date_start: dateStart,
      date_end: dateEnd,
      is_active: isActive,
      search_matched_edition: searchMatchedEdition,
    } = campaign;
    const detailsUrl = appIntl.urlPrefix + 'account/campaigns/' + id;
    return (

      <div className="campaignList" key={index}>
        <div className="campaignData" style={{display: 'grid'}} onClick={() => this.showDetails(detailsUrl)}>
          <h3>{title}</h3>
          {may(ROLE_ROOT_EMPLOYEE, user.roles) && campaign.creator !== null ? (
           <p style={{marginBottom: 0, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', width:'400px'}}>{campaign.creator.profile.first_name + ' ' + campaign.creator.profile.last_name + ' ' + campaign.creator.profile.email}</p>
          ) : <></>
          }
          {typeof searchMatchedEdition == 'string' && searchMatchedEdition.length > 0 && (
            <p style={{ color: '#cd1718', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', width:'400px', marginBottom: 0, marginTop: '0px' }} ><b>Edition</b>: {searchMatchedEdition}</p>)}
        </div>
        <Button className="c-settings" bsSize="small" onClick={() => showSettings(index, 'edit')}>
          <i className="fa fa-cog"/> {messages.campaign.settings}
        </Button>
        <SimplePrompt
          disabled={deleting}
          onSuccess={e => {
            handleRemoveClick(e, id);
          }}
        />
      </div>

    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};


export default connect(mapStateToProps)(CampaignListEntry);
